import { FetchResult, gql } from 'apollo-boost';
import { removeFields } from '../../../helpers/common-helpers';
import { INarrative } from '../../../models/narrative';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const QUERY = gql`
    query GetNarrative($uid: String!){
        narrative(uid: $uid) {
            uid,
            title,
            description,
            mediaType: media_type,
            platformType: platform_type,
            platforms: platforms,
            fileName: file_name,
            emailImageFileName: email_image_file_name,
            externalImageUrl: external_image_url,
            contentUrl: content_url,
            available,
            ipLicensed: ip_licensed,
            ignoreIPLicensing: ignore_ip_licensing,
            enabledAt: enabled_at,
            isNew: is_new,
            minAgeRating: min_age_rating,
            ratingLabel: rating_label,
            comingSoon: coming_soon,
            status,
            duration,
            audioSignatureFileName: audio_signature_file_name,
            audioCatalogFileName: audio_catalog_file_name,
            soundtrackFileName: soundtrack_file_name,

            topics {
                uid,
                name,
                description,
            },

            ipHolder: ip_holder {
                uid,
                name,
            },
            externalReferences: external_references {
                uid,
                serviceName: service_name,
                externalServiceUid: external_service_uid,
                externalServiceUrl: external_service_url,
                externalThumbnailUrl: external_thumbnail_url,
                infoPageUid: info_page_uid,
                preferredSource: preferred_source,
                timeOffset: time_offset,
                paidPlansOnly: paid_plans_only,
                enabled,
            }

            episodes {
                uid,
                name,
                season,
                numberInSeason: number_in_season,
                episodeType: episode_type,
                description,
                url,
                available,
                ipLicensed: ip_licensed,
                isNew: is_new,
                status,
                tasksAvailableForUserCount: tasks_available_for_user_count,
                embedable_status,
                externalReferences: external_references {
                    serviceName: service_name,
                    enabled,
                }
            },

            characters {
                uid,
                name,
                fileName: file_name,
                externalImageUrl: external_image_url,
                status,
                importance,
                inUse : in_use,
                autoGenerated: auto_generated,
            },

            scenes {
                uid,
                description,
                start: start,
                end: end,
                fileName: file_name,
                fileUrl: file_url,
                available,
                emotionEpisodeTypes: emotion_episode_types,

                emotionEpisodes: emotion_episodes {
                    uid,
                    description,
                    start,
                    end,
                    available,
                },

                episode {
                    uid,
                    name,
                    season,
                    numberInSeason: number_in_season
                }
            }

            endSurveyUid: end_survey_ref
        }
    }
`;

export async function getNarrative(uid: string): Promise<INarrative> {
    const result: FetchResult<{ narrative: INarrative }> = await graphqlClient.query({
        query: QUERY,
        variables: { uid },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return removeFields(result.data.narrative, ['__typename']);
}
